<form (submit)="save()">
  <div class="form-group">
    <label>Link</label>
    <input pInputText [(ngModel)]="stickyLink.link" name="link" [required]="true" />
  </div>
  <div class="form-group">
    <label>Text</label>
    <input pInputText [(ngModel)]="stickyLink.text" name="text" [required]="true" />
  </div>
  <div class="form-group">
    <label>Icon</label>
    <p-select
      [(ngModel)]="stickyLink.icon"
      [options]="ICONS"
      name="icon"
      appendTo="body"
      [required]="true"
    >
      <ng-template pTemplate="selectedItem">
        <div class="icon">
          <img *ngIf="stickyLink.icon" [src]="'/titleSvgs/' + stickyLink.icon" alt="icon" />
        </div>
      </ng-template>
      <ng-template let-icon pTemplate="item">
        <div class="icon">
          <img [src]="'/titleSvgs/' + icon" alt="icon" />
        </div>
      </ng-template>
    </p-select>
  </div>
  <div class="submit">
    <button pButton label="Cancel" (click)="cancel()" icon="pi pi-times" class="update"></button>
    <button pButton label="Save" type="submit" icon="pi pi-check" class="delete"></button>
  </div>
</form>
